import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const Methodo = ({ handleChange, checked, label }) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          color="primary"
          name="checked"
          onChange={handleChange}
        />
      }
      label={label}
    />
  );
};

export default Methodo;
